import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../html/element'
import { Panel } from '../../../panel'
import { ScrollComponent } from '../../../scrollComponent'
import {
  changeListSelectedListBusinessAge,
  resetBusinessAge,
  selectListSelectedBusinessAge,
} from '../../store/sliceBusinessAge'
import {
  changeListSelectedListBusinessSize,
  resetBusinessSize,
  selectListSelectedBusinessSize,
} from '../../store/sliceBusinessSize'
import {
  handelRemoveIdParent,
  resetIndustry,
  selectIndustry,
} from '../../store/sliceIndustry'
import {
  changeListSelected,
  changeListSelectedCompany,
  handleCheckAllPort,
  resetPortfolio,
  selectIsAllCheck,
  selectListSelected,
  selectListSelectedCompanyExclude,
} from '../../store/slicePortfolio'
import {
  changeListSelectedProvince,
  resetStoreProvince,
  selectListSelectedProvince,
} from '../../store/sliceProvince'
import { resetStoreScoreLevel } from '../../store/sliceScoreLevel'
import { GroupCriteria } from '../components/GroupCriteria'
import { GroupDisplayScore } from '../components/ScoreLevel/GroupDisplayScore'
import { covertTagDataIndustry } from '../helper'

export const Summary = () => {
  const dispatch = useDispatch()

  const listParentChecked = useSelector(selectIndustry('listParentChecked'))
  const data = useSelector(selectIndustry('industryVSICById'))
  const isAll = useSelector(selectIsAllCheck)

  const listSelectedPort = useSelector(selectListSelected)
  const listSelectedProvince = useSelector(selectListSelectedProvince)
  const listSelectedIndustry = covertTagDataIndustry(data, listParentChecked)
  const listSelectedBusinessAge = useSelector(selectListSelectedBusinessAge)
  const listSelectedBusinessSize = useSelector(selectListSelectedBusinessSize)
  const listIdsSelectedCompany = useSelector(selectListSelectedCompanyExclude)

  const onClickDeletePort = (value) => {
    dispatch(changeListSelected(value))

    if (listSelectedPort.length === 1) {
      dispatch(handleCheckAllPort())
    }
  }
  const onClickDeleteProvince = (value) => {
    dispatch(changeListSelectedProvince(value))
  }
  const onClickDeleteBusinessAge = (value) => {
    dispatch(changeListSelectedListBusinessAge(value))
  }
  const onClickDeleteBusinessSize = (value) => {
    dispatch(changeListSelectedListBusinessSize(value))
  }
  const onClickDeleteCompanyExclude = (value) => {
    dispatch(changeListSelectedCompany(value))
  }

  const handleDeleteIndustry = (item) => {
    dispatch(handelRemoveIdParent(item.value))
  }

  const handleClearAll = () => {
    dispatch(resetPortfolio())
    dispatch(resetStoreScoreLevel())
    dispatch(resetStoreProvince())
    dispatch(resetIndustry())
    dispatch(resetBusinessSize())
    dispatch(resetBusinessAge())
  }

  const renderWhenStatusAll = () => {
    return <Translate value="library.filterSetting.ALL_ITEMS_SELECT" />
  }

  return (
    <Panel
      isI18n
      label="library.filterSetting.SUMMARY"
      height={240}
      renderRightHeader={() => {
        return (
          <Element
            elementName="p"
            style={{ color: '#2C73E8' }}
            className="cursorPointer"
            onClick={handleClearAll}
          >
            <Translate value="library.filterCompanies.CLEAR_ALL" />
          </Element>
        )
      }}
    >
      <ScrollComponent>
        <div style={{ padding: '8px 12px' }}>
          <GroupCriteria
            label="library.savePortfolio.PORTFOLIO"
            data={listSelectedPort}
            onClickDelete={onClickDeletePort}
            notHidden
            isAll={isAll}
            renderWhenStatusAll={renderWhenStatusAll}
          />
          <GroupCriteria
            label="library.filterSetting.EXCLUDE"
            data={listIdsSelectedCompany}
            onClickDelete={onClickDeleteCompanyExclude}
          />
          <GroupDisplayScore />
          <GroupCriteria
            label="library.filterSetting.PROVINCE"
            data={listSelectedProvince}
            onClickDelete={onClickDeleteProvince}
          />
          <GroupCriteria
            label="library.filterSetting.INDUSTRY"
            data={listSelectedIndustry}
            onClickDelete={handleDeleteIndustry}
          />
          <GroupCriteria
            label="library.filterSetting.BUSINESS_SIZE"
            data={listSelectedBusinessSize}
            onClickDelete={onClickDeleteBusinessSize}
          />
          <GroupCriteria
            label="library.filterSetting.YEARS_OF_OPERATION"
            data={listSelectedBusinessAge}
            onClickDelete={onClickDeleteBusinessAge}
          />
        </div>
      </ScrollComponent>
    </Panel>
  )
}
